import { Controller } from "@hotwired/stimulus"

// Hover callout for the membership growth chart: a column per year shows a
// crosshair, that year's points, and a tooltip with all three series. The same
// values are in the chart's screen-reader table, so this layer is pointer-only.
export default class extends Controller {
  static targets = ["plot", "tooltip", "crosshair", "dot", "hit"]

  show(event) {
    const index = event.currentTarget.dataset.index
    const left = parseFloat(event.currentTarget.style.left)

    this.crosshairTarget.setAttribute("x1", left)
    this.crosshairTarget.setAttribute("x2", left)
    this.element.classList.add("is-inspecting")

    this.dotTargets.forEach((dot) => dot.classList.toggle("is-active", dot.dataset.index === index))

    this.tooltipTarget.querySelectorAll("[data-index]").forEach((body) => {
      body.hidden = body.dataset.index !== index
    })
    this.tooltipTarget.hidden = false
    this.tooltipTarget.style.left = `${left}%`
    // Open toward the middle of the plot so the callout never leaves it.
    this.tooltipTarget.classList.toggle("is-flipped", left > 50)
  }

  hide() {
    this.element.classList.remove("is-inspecting")
    this.dotTargets.forEach((dot) => dot.classList.remove("is-active"))
    this.tooltipTarget.hidden = true
  }
}
